<template>
  <v-container
    id="home"
    class="pt-12 pb-0 px-0"
    fluid
    tag="section"
  >
    <headline />
    <v-img :src="bigPicture" />
  </v-container>
</template>

<script>
  export default {
    name: 'Home',

    components: {
      // Gallery: () => import('@/components/Gallery'),
      Headline: () => import('./components/Headline'),
    },

    data: () => ({
      bigPicture: require('@/assets/mainpic.jpeg'),
    }),
  }
</script>
